import type { Manifest } from '../util/manifest';

const BACKMATTER_TYPES = [
  'backmatter',
  'appendix',
  'bibliography',
  'index',
  'glossary',
  'epilogue',
  'afterword',
  'conclusion',
  'contributors',
  'acknowledgments',
  'colophon',
  'imprint',
  'errata',
  'copyright-page',
  'other.recommendations',
  'other.backcover',
];

const getBodymatterIndex = (landmarks: Manifest['landmarks']) =>
  landmarks.find((l) => l.type === 'bodymatter')?.index ?? -1;

export const logLandmarksOnLoad = (manifest: Manifest) => {
  const { landmarks } = manifest;
  if (!landmarks.length) {
    console.log('[landmarks-debug] No landmarks found in this EPUB.');
    return;
  }
  const bodymatterIndex = getBodymatterIndex(landmarks);
  console.log('[landmarks-debug] EPUB Landmarks Initialized:');
  console.table(landmarks);
  console.log(
    `[landmarks-debug] Bodymatter starts at index: ${bodymatterIndex !== -1 ? bodymatterIndex : 'Not found'}`,
  );
};

const activeLandmarkAt = (landmarks: Manifest['landmarks'], index: number) => {
  for (let i = landmarks.length - 1; i >= 0; i--) {
    if (index >= landmarks[i].index) return landmarks[i];
  }
  return null;
};

export const logLandmarkOnRelocate = (manifest: Manifest, startIndex: number, endIndex: number) => {
  const { landmarks } = manifest;
  if (!landmarks.length) return;
  const bodymatterIndex = getBodymatterIndex(landmarks);

  const left = activeLandmarkAt(landmarks, startIndex);
  const right = startIndex === endIndex ? left : activeLandmarkAt(landmarks, endIndex);
  const visible = right && right !== left ? [left, right] : [left];

  console.debug('[landmarks-debug] Visible landmarks:', visible.map((l) => l?.type ?? '—').join(' | '));

  const furthest = right ?? left;
  if (!furthest) return;
  const isCompletionType = BACKMATTER_TYPES.includes(furthest.type);
  const isAfterBodymatter = bodymatterIndex !== -1 && furthest.index > bodymatterIndex;
  if (isCompletionType && isAfterBodymatter) {
    console.debug('[landmarks-debug] User has finished the main content.');
  }
};
